import { inject, ref } from "vue";
function useIsMobile() {
  const injected = inject("kontyIsMobile", null);
  if (injected) return injected;
  const mq = window.matchMedia("(max-width: 767.98px)");
  const r = ref(mq.matches);
  mq.addEventListener("change", (e) => {
    r.value = e.matches;
  });
  return r;
}
export {
  useIsMobile
};
//# sourceMappingURL=index110.js.map
